/* eslint-disable react/react-in-jsx-scope */
import { useQuery } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'

const getPOPlanningTable = async (inputObj) => {
  const { project, parentPart, weeksOut } = inputObj.queryKey[1]
  const PoPlanningTableAPIPath = `${API_URL}/api/purchaseOrder/v1/poPlanningTable?parentPart=${parentPart.partNumber}&weeksOut=${weeksOut}&project=${project}`

  const res = await axios.get(PoPlanningTableAPIPath).catch((err) => console.error(err))

  return res.data
}

export function usePOPlanningTable(project, parentPart, weeksOut = 20, setCtbData) {
  const options = {
    enabled: !!parentPart,
    onSuccess: (resData) => {
      let { data = [] } = resData

      let nz = 0
      for (let i = 0; i < data.length; i++) {
        if (data[i].partType) nz += 1
      }

      setCtbData({
        data,
      })
    },
    ...rqDefaultOptions,
  }
  return useQuery(['ctbTable', { project, parentPart, weeksOut }], getPOPlanningTable, options)
}
